var _a;
import { getNumericValue, numberFormat } from "../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { formState } from "../../../../themes/custom/ev_theme/frontend/js/modules/form/FormState";
const isSimulator = window.location.pathname.includes('simulador');
if (isSimulator) {
    const idForm = (_a = document.querySelector('.js-simulator')) === null || _a === void 0 ? void 0 : _a.getAttribute('id');
    formState.manageState('formName', '#' + idForm);
    const floatIframe = document.getElementById("avi-chat-float-frame");
    if (floatIframe === null || floatIframe === void 0 ? void 0 : floatIframe.contentWindow) {
        const origin = getNameCalculator();
        floatIframe.contentWindow.postMessage({
            type: "AVI_ORIGIN",
            payload: {
                origin: "AVI - " + origin,
            },
        }, "*");
    }
}
const idFormTpology = document.getElementById('typologyForm');
if (idFormTpology) {
    formState.manageState('formName', '#typologyForm');
}
formState.manageState('resultsCalculator', '.js-simulator-results');
window.setTimeMortgage = setTimeMortgage;
window.showFormSimulator = showFormSimulator;
const formatMathCurrency = (val) => `$ ${numberFormat(Math.trunc(val))}`;
const calculateMonthDiff = (start, end) => Math.max(0, (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()));
function setTimeMortgage(value, isModal) {
    const modalID = isModal ? 'firstTermSelectedModal' : 'firstTermSelected';
    const firstTermSelected = document.getElementById(modalID);
    const plazoInput = document.querySelector('input[name="plazo"]:checked');
    const otherOptions = document.querySelectorAll(".simulator__results-time .ev-tabs__item--simulator");
    if (value === 0) {
        firstTermSelected === null || firstTermSelected === void 0 ? void 0 : firstTermSelected.classList.add('active');
        otherOptions.forEach(option => option === null || option === void 0 ? void 0 : option.classList.remove('active'));
        value = parseInt(firstTermSelected.innerHTML.split(' años')[0]);
    }
    else {
        firstTermSelected === null || firstTermSelected === void 0 ? void 0 : firstTermSelected.classList.remove('active');
    }
    plazoInput ? plazoInput.value = value.toString() : '';
}
function showFormSimulator(nameForm) {
    const formContainer = document.getElementById(`${nameForm}FormContainer`);
    const resultsContainer = document.getElementById(`${nameForm}ResultsContainer`);
    const personalDataForm = document.getElementById(`${nameForm}PersonalDataForm`);
    const buttonsContainer = document.querySelectorAll('.js-end-buttons-container');
    const buttons = document.querySelectorAll('.js-submit-simulator-new');
    if (formContainer)
        formContainer.style.display = 'block';
    if (resultsContainer)
        resultsContainer.style.display = 'none';
    if (personalDataForm)
        personalDataForm.style.display = 'none';
    if (buttons.length > 0) {
        buttons[0].classList.remove('d-none');
    }
    if (buttonsContainer.length > 0) {
        buttonsContainer.forEach(container => container.classList.remove('d-none'));
    }
    localStorage.setItem('formSent', 'true');
}
export function simulatorIndebtedness() {
    var _a, _b;
    const ingresosFamiliares = getNumericValue(document.querySelector("input[name='ingreso']").value);
    const tipoVivienda = document.querySelector("input[name='vis_novis']").value;
    const plazoAnos = getNumericValue(document.querySelector("input[name='plazo']").value);
    const plazoMeses = plazoAnos * 12;
    let cuotaMaximaPermitida = 0;
    let tasaAnual = 0;
    let tasaAnualDecimal = 0;
    let tasaMensual = 0;
    let tasaMensualPorcentaje = 0;
    let factor = 0;
    let numerador = 0;
    let denominador = 0;
    let montoAproximado = 0;
    let valorMaximoInmueble = 0;
    let loanPercentage = 0;
    if (tipoVivienda === "VIS") {
        loanPercentage = 0.4;
        tasaAnual = Number((_a = document.getElementById('visPercentage')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-percentage'));
    }
    else {
        loanPercentage = 0.3;
        tasaAnual = Number((_b = document.getElementById('novisPercentage')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-percentage'));
    }
    tasaAnualDecimal = tasaAnual / 100;
    cuotaMaximaPermitida = ingresosFamiliares * loanPercentage;
    tasaMensual = Math.pow(1 + tasaAnualDecimal, 1 / 12) - 1;
    tasaMensualPorcentaje = tasaMensual * 100;
    factor = Math.pow(1 + tasaMensual, plazoMeses);
    numerador = factor - 1;
    denominador = tasaMensual * factor;
    montoAproximado = (cuotaMaximaPermitida * numerador) / denominador;
    valorMaximoInmueble = montoAproximado / 0.7;
    document.getElementById('value-family-income').innerHTML = formatMathCurrency(ingresosFamiliares);
    document.getElementById('value-annual-rate').innerHTML = tasaAnual.toFixed(2) + "%";
    document.getElementById('value-monthly-rate').innerHTML = tasaMensualPorcentaje.toFixed(2) + "%";
    document.getElementById('value-financial-years').innerHTML = plazoAnos.toString();
    const htmlTotalCharges = document.querySelectorAll('.js-total-indebtedness');
    const htmlPropertyValue = document.querySelectorAll('.js-value-max-property-fee');
    htmlTotalCharges.forEach(htmlElement => {
        htmlElement.innerHTML = formatMathCurrency(montoAproximado);
    });
    htmlPropertyValue.forEach(htmlElement => {
        htmlElement.innerHTML = formatMathCurrency(valorMaximoInmueble);
    });
    return `
    Monto aproximado del préstamo: $ ${formatMathCurrency(montoAproximado)},
    Valor máximo del inmueble: $ ${formatMathCurrency(valorMaximoInmueble)},
    Años de financiamiento: ${plazoAnos} años,
    Tasa Anual: ${tasaAnual.toFixed(2)}%,
    Tasa Mensual: ${tasaMensualPorcentaje.toFixed(2)}%,
    Ingresos Familiares Mensuales: $ ${formatMathCurrency(ingresosFamiliares)}
  `;
}
export function simulatorNotarialCharges() {
    const valorVivienda = getNumericValue(document.getElementById('price-project').value);
    const selectedCity = document.querySelector("input[name='city']").value;
    let isVis = false;
    const salario_minimo = 1750905;
    const topeValorViviendaVis = salario_minimo * (selectedCity === 'Bogotá' ? 150 : 135);
    if (valorVivienda <= topeValorViviendaVis) {
        isVis = true;
    }
    const notarialCalculus = notarialChargesByType(valorVivienda, isVis);
    const htmlTotalCharges = document.querySelectorAll('.js-total-notary-charges');
    const htmlPropertyValue = document.querySelectorAll('.js-value-property-fee');
    htmlTotalCharges.forEach(htmlElement => {
        htmlElement.innerHTML = formatMathCurrency(notarialCalculus.total);
    });
    htmlPropertyValue.forEach(htmlElement => {
        htmlElement.innerHTML = formatMathCurrency(valorVivienda);
    });
    const publicDeed = document.getElementById('value-public-deed');
    const publicDeedPercentage = document.getElementById('value-public-deed-percentage');
    const deedIva = document.getElementById('value-deed-iva');
    const charityTax = document.getElementById('value-charity-tax');
    const registrationRights = document.getElementById('value-registration-rights');
    if (publicDeed) {
        publicDeed.innerHTML = formatMathCurrency(notarialCalculus.publicDeed);
    }
    if (publicDeedPercentage) {
        publicDeedPercentage.innerHTML = `Este valor corresponde al ${notarialCalculus.visNoVis === 'VIS' ? '0,15%' : '0,3%'} del valor del inmueble.`;
    }
    if (deedIva) {
        deedIva.innerHTML = formatMathCurrency(notarialCalculus.notarialIVA);
    }
    if (charityTax) {
        charityTax.innerHTML = formatMathCurrency(notarialCalculus.charityTax);
    }
    if (registrationRights) {
        registrationRights.innerHTML = formatMathCurrency(notarialCalculus.registrationRights);
    }
    //   array:7 [▼
    //   0 => "Retención a la fuente: $500.000"
    //   1 => "Gastos notariales: $1.500.000"
    //   2 => "IVA: $285.000"
    //   3 => "Copias: $70.000"
    //   4 => "Impuesto de beneficiencia: $500.000"
    //   5 => "Impuesto de registro: $2.500.000"
    //   6 => "Certificado de tradición y Libertad: $18.000"
    // ]
    updateNotaryChargesChart(notarialCalculus);
    const calculos = `
    Escritura Pública: ${formatMathCurrency(notarialCalculus.publicDeed)},
    IVA Escritura Pública: ${formatMathCurrency(notarialCalculus.notarialIVA)},
    Impuesto de beneficencia: ${formatMathCurrency(notarialCalculus.charityTax)},
    Derechos de Registro: ${formatMathCurrency(notarialCalculus.registrationRights)},
    Total Gastos Notariales Estimados: ${formatMathCurrency(notarialCalculus.total)},
    Tipo de vivienda: ${notarialCalculus.visNoVis}
  `;
    return calculos;
}
let notaryChargesChart = null;
function calculatePercentage(value, total) {
    if (!total)
        return '0%';
    return `${((value / total) * 100).toFixed(1).replace('.', ',')}%`;
}
function setText(id, value) {
    const element = document.getElementById(id);
    if (element) {
        element.textContent = value;
    }
}
function updateNotaryLegend(notarialCalculus) {
    const publicDeed = notarialCalculus.publicDeed;
    const deedIva = notarialCalculus.notarialIVA;
    const charityTax = notarialCalculus.charityTax;
    const registrationRights = notarialCalculus.registrationRights;
    const total = notarialCalculus.total;
    const totalNotaryRights = publicDeed + deedIva;
    const totalRegistrationCosts = charityTax + registrationRights;
    setText('legend-charity-tax', formatMathCurrency(charityTax));
    setText('legend-charity-tax-percent', `(${calculatePercentage(charityTax, total)})`);
    setText('legend-registration-rights', formatMathCurrency(registrationRights));
    setText('legend-registration-rights-percent', `(${calculatePercentage(registrationRights, total)})`);
    setText('legend-public-deed', formatMathCurrency(publicDeed));
    setText('legend-public-deed-percent', `(${calculatePercentage(publicDeed, total)})`);
    setText('legend-deed-iva', formatMathCurrency(deedIva));
    setText('legend-deed-iva-percent', `(${calculatePercentage(deedIva, total)})`);
    setText('total-notary-rights', formatMathCurrency(totalNotaryRights));
    setText('summary-public-deed', formatMathCurrency(publicDeed));
    setText('summary-deed-iva', formatMathCurrency(deedIva));
    setText('total-registration-costs', formatMathCurrency(totalRegistrationCosts));
    setText('summary-charity-tax', formatMathCurrency(charityTax));
    setText('summary-registration-rights', formatMathCurrency(registrationRights));
}
function createNotaryCenterTextPlugin(total) {
    return {
        id: 'notaryCenterText',
        beforeDraw(chart) {
            const { ctx, chartArea } = chart;
            if (!chartArea)
                return;
            const centerX = (chartArea.left + chartArea.right) / 2;
            const centerY = (chartArea.top + chartArea.bottom) / 2;
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = '#1A1A1A';
            ctx.font = '400 13px Arial';
            ctx.fillText('Valor total de', centerX, centerY - 18);
            ctx.fillText('escrituración', centerX, centerY - 2);
            ctx.font = '700 22px Arial';
            ctx.fillText(formatMathCurrency(total), centerX, centerY + 24);
            ctx.restore();
        },
    };
}
function updateNotaryChargesChart(notarialCalculus) {
    const chartCanvas = document.getElementById('notaryChargesChart');
    if (!chartCanvas)
        return;
    if (typeof Chart === 'undefined') {
        console.warn('Chart.js no está disponible. Revisa que el CDN esté cargando antes de ejecutar la gráfica.');
        return;
    }
    const labels = [
        'Impuesto de Beneficencia',
        'Derechos de Registro',
        'Escritura Pública',
        'IVA Escritura Pública',
    ];
    const data = [
        notarialCalculus.charityTax,
        notarialCalculus.registrationRights,
        notarialCalculus.publicDeed,
        notarialCalculus.notarialIVA,
    ];
    const colors = [
        '#079CBD',
        '#005D96',
        '#FF8200',
        '#10A970',
    ];
    if (notaryChargesChart) {
        notaryChargesChart.destroy();
    }
    notaryChargesChart = new Chart(chartCanvas, {
        type: 'doughnut',
        data: {
            labels,
            datasets: [
                {
                    data,
                    backgroundColor: colors,
                    borderWidth: 4,
                    borderColor: '#ffffff',
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '68%',
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label(context) {
                            const value = context.raw;
                            const percentage = calculatePercentage(value, notarialCalculus.total);
                            return `${context.label}: ${formatMathCurrency(value)} (${percentage})`;
                        },
                    },
                },
            },
        },
        plugins: [createNotaryCenterTextPlugin(notarialCalculus.total)],
    });
    updateNotaryLegend(notarialCalculus);
}
function notarialChargesByType(housePrice, isVis) {
    const ivaPercentage = 0.19;
    const buyerPercentage = 0.5;
    const charityTaxPercentage = 0.01;
    const registrationRightsPercentage = 0.005;
    let publicDeed = isVis ? housePrice * 0.0015 : housePrice * 0.003;
    const visNoVis = isVis ? 'VIS' : 'NO VIS';
    publicDeed = roundToCents(publicDeed * buyerPercentage);
    let notarialIVA = roundToCents(publicDeed * ivaPercentage);
    let totalPublicDeed = roundToCents(publicDeed + notarialIVA);
    let charityTax = roundToCents(housePrice * charityTaxPercentage);
    let registrationRights = roundToCents(housePrice * registrationRightsPercentage);
    let total = roundToCents(totalPublicDeed + charityTax + registrationRights);
    return {
        publicDeed,
        visNoVis,
        notarialIVA,
        totalPublicDeed,
        charityTax,
        registrationRights,
        total
    };
}
function roundToCents(value) {
    return Math.round(value / 100) * 100;
}
export function simulatorDownPayment() {
    const valorVivienda = getNumericValue(document.getElementById('price-project').value);
    const inputCredito = document.querySelector("input[name='input_credito']:checked").value;
    const porcentaje = inputCredito === 'Crédito Hipotecario' ? 0.3 : 0.2;
    const downPaymentPercentage = inputCredito === 'Crédito Hipotecario' ? 30 : 20;
    const cuotaInicial = valorVivienda * porcentaje;
    const fechaCuota = document.getElementById('fecha_cuota').value;
    const months = calculateMonthDiff(new Date(), new Date(fechaCuota));
    const ahorrosCuota = document.getElementById('ahorros_cuota').value;
    const ahorros = getNumericValue(ahorrosCuota);
    const saldoDiferir = valorVivienda - cuotaInicial;
    const saldoCuotaDiferir = cuotaInicial - ahorros;
    const cuotaMensualCuotaInicial = months > 0 ? saldoCuotaDiferir / months : 0;
    document.getElementById('value-term-fee').innerHTML = months.toString();
    document.getElementById('value-savings').innerHTML = formatMathCurrency(ahorros);
    document.getElementById('value-property-fee').innerHTML = formatMathCurrency(valorVivienda);
    document.getElementById('value-balance').innerHTML = formatMathCurrency(saldoCuotaDiferir);
    document.getElementById('value-total-balance').innerHTML = formatMathCurrency(saldoDiferir);
    document.querySelectorAll('.js-down-payment').forEach(el => {
        el.innerHTML = formatMathCurrency(cuotaInicial);
    });
    document.querySelectorAll('.js-monthly-payment').forEach(el => {
        el.innerHTML = formatMathCurrency(cuotaMensualCuotaInicial);
    });
    document.querySelectorAll('.js-fee-percentage').forEach(el => {
        el.innerHTML = `Este valor corresponde al ${downPaymentPercentage}% del valor del inmueble.`;
    });
    return `
    Valor inmueble: ${formatMathCurrency(valorVivienda)},
    Plazo cuota inicial: ${months} meses,
    Cuota inicial: ${formatMathCurrency(cuotaInicial)},
    Ahorros y primas: ${formatMathCurrency(ahorros)},
    Saldo a diferir: ${formatMathCurrency(saldoDiferir)}
  `;
}
function getNameCalculator() {
    const urlCalculator = window.location.pathname;
    let nameCalculator = "Simuladores";
    switch (urlCalculator) {
        case '/simulador-de-subsidio':
            nameCalculator = `Simulador de Subsidio`;
            break;
        case '/simulador-credito-hipotecario':
            nameCalculator = `Simulador Hipotecaria`;
            break;
        case '/simulador-de-cuota-inicial':
            nameCalculator = `Simulador Cuota inicial`;
            break;
        case '/simulador-de-endeudamiento':
            nameCalculator = `Simulador de Endeudamiento`;
            break;
        case '/simulador-de-gastos-notariales':
            nameCalculator = `Simulador de Gastos notariales`;
            break;
    }
    return nameCalculator;
}
